import { render, staticRenderFns } from "./DeliveryMenuMaterializeDialog.vue?vue&type=template&id=b1a04852&scoped=true"
import script from "./DeliveryMenuMaterializeDialog.vue?vue&type=script&lang=js"
export * from "./DeliveryMenuMaterializeDialog.vue?vue&type=script&lang=js"
import style0 from "./DeliveryMenuMaterializeDialog.vue?vue&type=style&index=0&id=b1a04852&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1a04852",
  null
  
)

export default component.exports